export * from "-!../../../../node_modules/babel-loader/lib/index.js??ref--2!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!../../../../node_modules/vue-svg-inline-loader/dist/index.min.js!./ModalView.vue?vue&type=template&id=749f3788"


//////////////////
// WEBPACK FOOTER
// ./resources/js/Components/new/ModalView.vue?vue&type=template&id=749f3788
// module id = 262
// module chunks = 5 12 13